import styled, { css } from 'vue-styled-components';

import {
    FLEX_COLUMN_ALIGN_CENTER_DIV,
    FLEX_DIV,
} from '@/styles/common.styled.component';
import { BLUE, GRAY } from '@/styles/common.styled';

export const AddBtn = styled.div`
    width: 60px;
    height: 20px;
    border-radius: 50px;
    background-color: ${GRAY(30)};
    color: white;
    text-align: center;
    font-weight: 500;
`;

export const FilterGroupWrapper = styled(FLEX_COLUMN_ALIGN_CENTER_DIV)`
    width: 100%;
    gap: 10px;
    padding: 16px 16px 10px;
    border-radius: 2px;
    border: 1px solid #cfd0d1;
    background: ${GRAY(5)};
`;

export const FilterGroupHeader = styled(FLEX_DIV)`
    width: 100%;
    justify-content: space-between;
    margin-bottom: 2px;
`;

export const FilterGroupTitle = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-self: flex-start;
    color: ${GRAY(100)};
    font-weight: 500;
`;

export const FilterGroupValueWrapper = styled.div`
    display: flex;
    gap: 5px;
    flex-wrap: wrap;
    width: 100%;
    align-self: flex-start;
    color: ${GRAY(100)};
    font-weight: 500;
    margin-top: 5px;
`;

export const ResetButton = styled.button`
    padding-left: 20px;
    color: ${BLUE(60)};
    font-weight: 500;
`;

export const ApplyAddBtnCss = css`
    gap: 4px;
    width: 80px;
    height: 32px;
    padding: 0 16px;
    border-radius: 50px;
    font-size: 13px;
`;


export const TitleWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

export const TitleText = styled.div`
    font-size: 14px;
    font-weight: 500;
    color: ${GRAY(100)};
`;

export const InputFieldWrapper = styled.div`
    width: 100%;

    & .label-name-input-field {
        width: 100%;

        input {
            width: 100% !important;
        }
    }
`;
